var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"container"},[_c('PageTabs',{attrs:{"tabs":_vm.tabs,"activeTab":_vm.activeTab}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }